import { Switch } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface ToggleFieldProps {
  value?: string;
  onChange?: (value: string) => void;
}

const ToggleField = (props: ToggleFieldProps) => {
  const { value, onChange } = props;

  const { t } = useTranslation();

  const handleToggleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    if (onChange) {
      onChange(checked ? t("yes") : t("no"));
    }
  };
  return (
    <div className="dui-toggle-wrapper">
      <div>{t("no")}</div>
      <Switch
        onChange={handleToggleChange}
        checked={value === "true" || value === t("yes")}
      />
      <div>{t("yes")}</div>
    </div>
  );
};

export default ToggleField;
